export default "__VITE_ASSET__8d1df23b__"